<template>
    <div class="main">
        <c-panel title="BAIXA DE ESTOQUE" titleIcon="fas fa-arrow-down">
            <el-alert type="info" :closable="false" class="u-mb-15" show-icon
                title="Registre aqui o material consumido pela unidade. A baixa reduz o estoque e fica no histórico."></el-alert>

            <el-form label-position="top" :model="dados" ref="dados" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="8">
                        <el-form-item label="Unidade" prop="instituicao_id" :rules="[$requiredChange]">
                            <el-select v-if="ehSmed" v-model="dados.instituicao_id" filterable placeholder="Selecione"
                                :disabled="temItens" style="width:100%;" @change="trocarUnidade">
                                <el-option v-for="i in listaInstituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                            <el-input v-else :value="nomeInstituicao" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="6" :md="4">
                        <el-form-item label="Data">
                            <el-date-picker v-model="dados.data_movimento" type="date" format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12">
                        <el-form-item label="Observação">
                            <el-input v-model="dados.observacao" maxlength="255"
                                placeholder="Ex.: consumo da semana, limpeza geral"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>

        <c-panel title="PRODUTOS CONSUMIDOS" titleIcon="fas fa-boxes">
            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="5">
                        <el-form-item label="Grupo">
                            <el-select v-model="linha.grupo_id" filterable clearable placeholder="Todos"
                                style="width:100%;" @change="trocarGrupo">
                                <el-option label="Todos" value=""></el-option>
                                <el-option v-for="g in grupos" :key="g.id" :label="g.nome" :value="g.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16" :md="11">
                        <el-form-item label="Produto">
                            <el-select v-model="linha.produto_id" filterable remote clearable
                                :remote-method="buscarProduto" :loading="buscando"
                                placeholder="Digite o nome ou o código" style="width:100%;" @change="selecionarProduto">
                                <el-option v-for="p in produtos" :key="p.id" :label="rotuloProduto(p)" :value="p.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="8" :sm="5" :md="3">
                        <el-form-item label="Saldo">
                            <el-input :value="linha.produto ? formataQtd(linha.produto.saldo) : ''" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="10" :sm="6" :md="3">
                        <el-form-item label="Baixar">
                            <el-input v-model="linha.quantidade" @keyup.enter.native="incluir" placeholder="0"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="6" :sm="5" :md="2">
                        <el-form-item label="&nbsp;">
                            <el-button type="primary" icon="el-icon-plus" @click="incluir" style="width:100%;">INCLUIR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Produto</th>
                            <th style="width:100px;" class="u-text-center">Unidade</th>
                            <th style="width:110px;" class="u-text-center">Saldo</th>
                            <th style="width:110px;" class="u-text-center">Baixa</th>
                            <th style="width:120px;" class="u-text-center">Saldo depois</th>
                            <th style="width:70px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(it, i) in dados.itens" :key="i">
                            <td>{{ it.nome }}</td>
                            <td class="u-text-center">{{ it.unidade_medida }}</td>
                            <td class="u-text-center">{{ formataQtd(it.saldo) }}</td>
                            <td class="u-text-center">{{ formataQtd(it.quantidade) }}</td>
                            <td class="u-text-center">{{ formataQtd(it.saldo - it.quantidade) }}</td>
                            <td class="u-text-center">
                                <el-button size="mini" type="danger" plain icon="el-icon-delete"
                                    title="Remover item" @click="dados.itens.splice(i, 1)"></el-button>
                            </td>
                        </tr>
                        <tr v-if="!dados.itens.length">
                            <td colspan="6" class="u-text-center" style="color:#909399; padding:12px;">Nenhum item incluído.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <el-row :gutter="10" class="u-mt-15">
                <el-col :xs="24" :sm="12">
                    <strong>Total de itens:</strong> {{ dados.itens.length }}
                </el-col>
                <el-col :xs="24" :sm="12" class="u-text-right">
                    <el-button type="primary" icon="el-icon-check" @click="salvar" :disabled="!dados.itens.length">
                        CONFIRMAR BAIXA
                    </el-button>
                </el-col>
            </el-row>
        </c-panel>

        <c-panel title="HISTÓRICO DE BAIXAS" titleIcon="fas fa-history">
            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="9">
                        <el-form-item label="Período">
                            <el-date-picker v-model="filtro.periodo" type="daterange" format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                                range-separator="até" start-placeholder="Data inicial" end-placeholder="Data final" style="width:100%;"
                                @change="carregarMovimentos(1)"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="7" v-if="ehSmed">
                        <el-form-item label="Unidade">
                            <el-select v-model="filtro.instituicao_id" filterable clearable placeholder="Todas" style="width:100%;" @change="carregarMovimentos(1)">
                                <el-option v-for="i in listaInstituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="ehSmed ? 5 : 8">
                        <el-form-item label="Produto">
                            <el-input v-model="filtro.busca" clearable placeholder="Nome ou código" @keyup.native.enter="carregarMovimentos(1)" @clear="carregarMovimentos(1)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="3" class="u-text-right" style="padding-top: 30px;">
                        <el-button type="primary" plain icon="el-icon-printer" :loading="imprimindo" @click="imprimir()">IMPRIMIR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table" v-loading="carregando">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width:100px;">Data</th>
                            <th>Produto</th>
                            <th v-if="ehSmed">Unidade</th>
                            <th>Observação</th>
                            <th style="width:110px;" class="u-text-center">Quantidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="m in movimentos" :key="m.id">
                            <td>{{ formataData(m.data_movimento) }}</td>
                            <td>{{ m.produto ? m.produto.nome : '—' }}</td>
                            <td v-if="ehSmed">{{ m.instituicao ? m.instituicao.nome : '—' }}</td>
                            <td>{{ m.observacao || '—' }}</td>
                            <td class="u-text-center baixa-qtd">-{{ formataQtd(m.quantidade) }}</td>
                        </tr>
                        <tr v-if="!movimentos.length">
                            <td :colspan="ehSmed ? 5 : 4" class="u-text-center" style="color:#909399; padding:12px;">
                                Nenhuma baixa encontrada.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <el-row :gutter="10" class="u-mt-10">
                <el-col :xs="24" :sm="12">
                    <div class="u-text-left u-mt-10">Mostrando {{ paginate.from || 0 }} até {{ paginate.to || 0 }} de {{ paginate.total }} registros.</div>
                </el-col>
                <el-col :xs="24" :sm="12" v-if="paginate.total > paginate.porPagina">
                    <div class="u-text-right">
                        <el-pagination :current-page="paginate.page" :total="paginate.total" :page-size="paginate.porPagina" background small
                            layout="prev, pager, next" @current-change="carregarMovimentos"></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </c-panel>
    </div>
</template>

<script>
/**
 * Baixa de estoque: a unidade registra o que consumiu.
 *
 * Diferente da requisição (que traz material) e da transferência (que muda de
 * lugar): aqui o material sai porque foi usado, e não vai para lugar nenhum.
 * Vários produtos são baixados de uma vez, em um único documento.
 */
export default {
    data: () => ({
        carregando: false,
        buscando: false,
        grupos: [],
        produtos: [],
        movimentos: [],
        imprimindo: false,
        filtro: { periodo: null, instituicao_id: '', busca: '' },
        paginate: { page: 1, total: 0, from: 0, to: 0, porPagina: 30 },
        linha: { grupo_id: '', produto_id: null, produto: null, quantidade: '' },
        dados: { instituicao_id: '', data_movimento: '', observacao: '', itens: [] }
    }),
    computed: {
        ehSmed () { return [4, 5, 6, 7, 8, 10].includes(Number(this.$store.state.user.tipo)) },
        /** A store guarda as instituições como objeto; iterar e comparar exige normalizar. */
        listaInstituicoes () {
            const v = this.$store.state.instituicoes
            return Array.isArray(v) ? v : Object.values(v || {})
        },
        nomeInstituicao () { return this.$store.state.config.instituicao.nome || '-' },
        temItens () { return this.dados.itens.length > 0 }
    },
    mounted () {
        this.dados.data_movimento = this.$moment().format('YYYY-MM-DD')

        if (!this.ehSmed) this.dados.instituicao_id = this.$store.state.config.instituicao.id

        this.carregarGrupos()
        this.carregarMovimentos()
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },
        aviso (msg) { window.eventBus.$emit('alert', { msg, type: 'warning' }) },
        formataQtd (v) { const n = Number(v) || 0; return n % 1 === 0 ? String(n) : n.toFixed(3) },
        formataData (d) { return d ? this.$moment(d).format('DD/MM/YYYY') : '—' },
        rotuloProduto (p) {
            const unidade = String(p.unidade_medida || 'UN').toLowerCase()
            return `${p.nome} - (${this.formataQtd(p.saldo)} ${unidade})`
        },

        carregarGrupos () {
            this.$axios.get(`${this.baseUrl()}/api/almox-grupo/getAll?situacao=true`, this.auth())
                .then(r => { this.grupos = r.data || [] }).catch(e => this.$store.commit('throwException', e))
        },
        /** Filtros do histórico: perfis de unidade só veem a própria; a rede pode escolher a unidade. */
        filtroHistorico () {
            const f = { tipo: 2 }
            if (this.filtro.periodo && this.filtro.periodo.length === 2) {
                f.data_inicio = this.filtro.periodo[0]
                f.data_fim = this.filtro.periodo[1]
            }
            if (this.filtro.busca && this.filtro.busca.trim()) f.busca = this.filtro.busca.trim()
            if (this.ehSmed) {
                if (this.filtro.instituicao_id) f.instituicao_id = this.filtro.instituicao_id
            } else {
                f.instituicao_id = this.dados.instituicao_id
            }
            return f
        },
        carregarMovimentos (page) {
            this.carregando = true
            const pagina = typeof page === 'number' ? page : 1

            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/movimentos?page=${pagina}`, this.filtroHistorico(), this.auth())
                .then(r => {
                    const d = r.data || {}
                    this.movimentos = d.data || []
                    this.paginate = { page: d.current_page || 1, total: d.total || 0, from: d.from || 0, to: d.to || 0, porPagina: d.per_page || 30 }
                    this.carregando = false
                })
                .catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },
        imprimir () {
            this.imprimindo = true

            this.$axios.post(`${this.baseUrl()}/api/almox-estoque/baixa/pdf`, this.filtroHistorico(), this.$store.getters.getHeaderAuthExcel)
                .then(r => {
                    this.imprimindo = false
                    const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
                    const novaAba = window.open(url, '_blank')
                    if (!novaAba) window.location.href = url
                })
                .catch(e => { this.imprimindo = false; this.aviso('Erro ao gerar o relatório.'); this.$store.commit('throwException', e) })
        },

        /* ------------------------- linha de inclusão ------------------------- */
        buscarProduto (termo) {
            const busca = (termo || '').trim()

            if (!this.dados.instituicao_id) { this.aviso('Selecione a unidade primeiro.'); return }
            if (!this.linha.grupo_id && busca.length < 2) { this.produtos = []; return }

            this.buscando = true

            this.$axios.post(`${this.baseUrl()}/api/almox-produto/buscar`,
                { grupo_id: this.linha.grupo_id || null, busca, instituicao_id: this.dados.instituicao_id, limite: 30 },
                this.auth())
                .then(r => { this.produtos = r.data || []; this.buscando = false })
                .catch(e => { this.buscando = false; this.$store.commit('throwException', e) })
        },
        trocarGrupo () { this.limparLinha(); if (this.linha.grupo_id) this.buscarProduto('') },
        trocarUnidade () {
            // O saldo é por unidade: trocar invalida o que está na tela.
            this.produtos = []
            this.limparLinha()
            this.carregarMovimentos(1)
        },
        selecionarProduto (id) { this.linha.produto = this.produtos.find(p => p.id === id) || null },
        limparLinha () {
            this.linha.produto_id = null
            this.linha.produto = null
            this.linha.quantidade = ''
        },

        incluir () {
            const p = this.linha.produto

            if (!p) { this.aviso('Selecione o produto.'); return }

            const qtd = Number(String(this.linha.quantidade).replace(',', '.'))

            if (!(qtd > 0)) { this.aviso('Informe uma quantidade maior que zero.'); return }

            if (this.dados.itens.some(it => it.produto_id === p.id)) {
                this.aviso('Este produto já foi incluído nesta baixa.')
                return
            }

            // A trava real está no servidor; aqui é para o usuário não montar uma
            // lista inteira e só descobrir o problema no final.
            if (qtd > Number(p.saldo)) {
                this.aviso(`Saldo insuficiente de ${p.nome}. Disponível: ${this.formataQtd(p.saldo)}.`)
                return
            }

            this.dados.itens.push({
                produto_id: p.id,
                nome: p.nome,
                unidade_medida: p.unidade_medida,
                saldo: p.saldo,
                quantidade: qtd
            })

            this.limparLinha()
        },

        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { this.aviso('Preencha os campos obrigatórios.'); return }
                if (!this.dados.itens.length) { this.aviso('Inclua pelo menos um item.'); return }

                this.$msgbox.confirm(
                    `Confirmar a baixa de ${this.dados.itens.length} item(ns) do estoque?`, 'Atenção',
                    { confirmButtonText: 'Sim, dar baixa', cancelButtonText: 'Cancelar', type: 'warning' }
                ).then(() => {
                    window.eventBus.$emit('loading', true)

                    const payload = {
                        instituicao_id: this.dados.instituicao_id,
                        data_movimento: this.dados.data_movimento,
                        observacao: this.dados.observacao,
                        itens: this.dados.itens.map(it => ({ produto_id: it.produto_id, quantidade: it.quantidade }))
                    }

                    this.$axios.post(`${this.baseUrl()}/api/almox-estoque/baixa`, payload, this.auth())
                        .then(r => {
                            window.eventBus.$emit('loading', false)
                            if (r.data && r.data.erro) { this.aviso(r.data.erro); return }

                            window.eventBus.$emit('alert', { msg: 'Baixa registrada com sucesso.', type: 'success' })
                            this.dados.itens = []
                            this.dados.observacao = ''
                            this.limparLinha()
                            this.carregarMovimentos()
                        })
                        .catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
                }).catch(() => {})
            })
        }
    }
}
</script>

<style scoped>
.baixa-qtd { color: #f56c6c; font-weight: bold; }
</style>
